import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";
import "../css/adminOrders.scss";
import { mockOrders } from "../Datas/orderData";

function AdminOrders() {
  const navigate = useNavigate();
  const [orders, setOrders] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);

  useEffect(() => {
   setOrders(mockOrders);
      setCurrentPage(1);
  }, [navigate]);

  const totalPages = Math.max(1, Math.ceil(orders.length / pageSize));
  const pageStartIndex = (currentPage - 1) * pageSize;
  const pageEndIndex = pageStartIndex + pageSize;
  const paginatedOrders = orders.slice(pageStartIndex, pageEndIndex);

  useEffect(() => {
    if (currentPage > totalPages) {
      setCurrentPage(totalPages);
    }
  }, [currentPage, totalPages]);

  const handleLogout = () => {
    localStorage.removeItem("isAdmin");
    navigate("/admin/login");
  };

  const getStatusClass = (status) => {
    switch (status) {
      case "Delivered":
        return "status-delivered";
      case "Shipped":
        return "status-shipped";
      case "Processing":
        return "status-processing";
      case "Pending":
        return "status-pending";
      default:
        return "";
    }
  };

  const handleRowClick = (id) => {
    navigate(`/admin/orders/${id}`);
  };

  const handlePrevPage = () => {
    setCurrentPage((p) => Math.max(1, p - 1));
  };

  const handleNextPage = () => {
    setCurrentPage((p) => Math.min(totalPages, p + 1));
  };

  const handlePageSizeChange = (e) => {
    const nextSize = Number(e.target.value);
    setPageSize(nextSize);
    setCurrentPage(1);
  };

  const pageNumbers = Array.from({ length: totalPages }, (_, i) => i + 1);

  return (
    <div className="admin-page">
      <Header />
      <div className="admin-container">
        <div className="orders-table-container">
          <div className="admin-header">
            <h2>Recent Orders</h2>
            <button onClick={handleLogout} className="logout-btn">
              Logout
            </button>
          </div>
          <div className="table-responsive-wrapper">
            <table className="orders-table">
              <thead>
                <tr>
                  <th>Order ID</th>
                  <th>Customer</th>
                  <th>Date</th>
                  <th>Shipping Info</th>
                  <th>Items</th>
                  <th>Total</th>
                  <th>Status</th>
                  <th>Tracking</th>
                </tr>
              </thead>
              <tbody>
                {paginatedOrders.map((order) => (
                  <tr key={order.id} onClick={() => handleRowClick(order.id)} style={{ cursor: "pointer" }} className="order-row">
                    <td className="order-id">{order.id}</td>
                    <td>{order.customer}</td>
                    <td className="order-date">{order.date}</td>
                    <td>
                      {order.shippingAddress ? (
                        <div className="shipping-info">
                          <div><strong>{order.shippingAddress.receiver}</strong></div>
                          <div>{order.shippingAddress.phone}</div>
                          <div style={{ color: "#777", marginTop: "2px", lineHeight: "1.3" }}>
                            {order.shippingAddress.address}
                          </div>
                        </div>
                      ) : (
                        <span style={{ color: "#999" }}>-</span>
                      )}
                    </td>
                    <td className="order-items">
                      {order.items.map((item, index) => (
                        <div key={index} className="order-item-row">
                          <img src={item.image} alt={item.name} className="item-thumb" />
                          <span>{item.quantity}x {item.name}</span>
                        </div>
                      ))}
                    </td>
                    <td className="order-total">€{order.total.toFixed(2)}</td>
                    <td>
                      <span className={`status-badge ${getStatusClass(order.status)}`}>
                        {order.status.toUpperCase()}
                      </span>
                    </td>
                    <td className="tracking-col">
                      {order.trackingNumber || <span style={{ color: "#999" }}>-</span>}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <div className="pagination">
            <div className="pagination-info">
              {orders.length > 0
                ? `Showing ${pageStartIndex + 1}-${Math.min(pageEndIndex, orders.length)} of ${orders.length}`
                : "No orders"}
            </div>
            <div className="pagination-controls">
              <button type="button" onClick={handlePrevPage} disabled={currentPage === 1}>
                Prev
              </button>
              {pageNumbers.map((page) => (
                <button
                  key={page}
                  type="button"
                  className={page === currentPage ? "active" : ""}
                  onClick={() => setCurrentPage(page)}
                >
                  {page}
                </button>
              ))}
              <button type="button" onClick={handleNextPage} disabled={currentPage === totalPages}>
                Next
              </button>
            </div>
            <div className="pagination-size">
              <select value={pageSize} onChange={handlePageSizeChange}>
                <option value={5}>5 / page</option>
                <option value={10}>10 / page</option>
                <option value={20}>20 / page</option>
              </select>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default AdminOrders;
